import { render, staticRenderFns } from "./addWay.vue?vue&type=template&id=2c9dc58c&scoped=true&"
import script from "./addWay.vue?vue&type=script&lang=js&"
export * from "./addWay.vue?vue&type=script&lang=js&"
import style0 from "./addWay.vue?vue&type=style&index=0&id=2c9dc58c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9dc58c",
  null
  
)

export default component.exports